	
	const config = {
			'threshold' : .15,
			'hidden_class' : 'to-fade',
			'active_class' : 'fade',
		},
		items = [...document.querySelectorAll( '.js-fade-in' )];

	if ( items ) {
		items.forEach( item => item.classList.add( config.hidden_class ) );
		window.addEventListener( 'scroll', function () { scroll(); } );
		scroll();
	}

	function scroll () {
		for ( const item of items ) {
			if ( item.offsetTop - window.pageYOffset < window.innerHeight * ( 1 - config.threshold ) ) {
				item.classList.add( config.active_class );
				items.splice( items.indexOf( item ), 0 );
			} else break;
		}
	}
	